import { useState, useEffect } from "react"
import Lib from 'library'

const useCommonCode = (code, set) => {
	const [codes, setCodes] = useState()

	useEffect(() => {
		Lib.get(`/api/comm/cd/${code}`, data => {
			if (set) {
				setCodes(set(data))
			} else {
				setCodes(data)
			}
		})
	}, [])
	return codes
}

export default useCommonCode
